var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckCopy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 25,
    height: 25,
    rx: 12.5,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.9226 14.9252L7.93963 12.3132L6.94531 13.1839L10.9226 16.6665L19.4453 9.20378L18.451 8.33313L10.9226 14.9252Z",
    fill: "#334588"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckCopy);
export default __webpack_public_path__ + "static/media/checkCopy.ae66f293cea86ff8866e03c5858d3eae.svg";
export { ForwardRef as ReactComponent };